import React from 'react';
import { IExternalFeed } from '../../dto/IExternalSearchProfile';
import { IExternalImageData } from '../../dto/IDetailModalData';
import { ExternalPosts } from './ExternalPosts';

interface IExternalProfileContentTabProps {
    feed?: IExternalFeed[];
    about?: string;
    externalImageData?: IExternalImageData;
}

export function ExternalProfileContentTab({ feed, about, externalImageData }: IExternalProfileContentTabProps) {
    return (
        <div className="p-3">
            {about && (
                <>
                    <h4>About</h4>
                    <p className="text-muted">{about}</p>
                </>
            )}
            {/*<h6>*/}
            {/*    Highlighted posts*/}
            {/*</h6>*/}
            {/*<Row>*/}
            {/*    {feed?.map(*/}
            {/*        (item) =>*/}
            {/*            <Col key={item?.id} sm={4} lg={3}>*/}
            {/*                <Fancybox>*/}
            {/*                    <div*/}
            {/*                        data-fancybox="content-gallery"*/}
            {/*                        className="cursor-pointer"*/}
            {/*                        data-src={item?.thumbnail ?? '/icons/filePlaceholder.png'}*/}
            {/*                    >*/}
            {/*                        <CustomImageHandler*/}
            {/*                            altTag="Social platforms feed images"*/}
            {/*                            classes="feed-image box-shadow"*/}
            {/*                            thumbnailPath={item?.thumbnail ?? ''}*/}
            {/*                            photoPath={item?.thumbnail ?? ''}*/}
            {/*                        />*/}
            {/*                    </div>*/}
            {/*                </Fancybox>*/}
            {/*            </Col>,*/}
            {/*    )}*/}
            {/*</Row>*/}
            {externalImageData?.sponsoredPosts && externalImageData?.sponsoredPosts?.length > 0 && (
                <div className={externalImageData?.popularPosts?.length ? 'mt-2' : ''}>
                    <h4 className="mb-2">Sponsored posts</h4>
                    <ExternalPosts externalPosts={externalImageData?.sponsoredPosts} isSponsored={true} />
                </div>
            )}
            {externalImageData?.popularPosts && externalImageData?.popularPosts?.length > 0 && (
                <>
                    <h4 className="mb-2">Popular posts</h4>
                    <ExternalPosts externalPosts={externalImageData?.popularPosts} />
                </>
            )}
        </div>
    );
}
